import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import AboutIntro from './components/AboutIntro';
import CategoryGrid from './components/CategoryGrid';
import ArticlePreview from './components/ArticlePreview';
import Testimonial from './components/Testimonial';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://kakobuyfinds.living';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Kakobuy Finds',
  url: SITE_URL,
  description: 'The ultimate spreadsheet database for smart shopping research — discover the best product finds, lists, and organized shopping guides across fashion, sneakers, electronics, and more.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Kakobuy Finds',
  url: SITE_URL,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
  sameAs: [SITE_URL],
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <Hero />
      <AboutIntro />
      <CategoryGrid />
      <ArticlePreview />
      <Testimonial />
      <FinalCTA />
      <Footer />
    </main>
  );
}